import { API } from "../../../services/api";

export const INVITATION_REFRESH_MS = 15 * 1000;

export const INVALID_INVITATION_EMAIL = "L'adresse email d'invitation n'est pas valide.";

// Ajoute l'email de raccordement aux emails de contact s'il n'y est pas déjà (sans tenir compte de la casse).

export function withContactEmail(emails, email) {
    if (!email || emails.some(existing => existing.toLowerCase() === email.toLowerCase())) return emails;
    return [...emails, email];
}

// Contrôles sans expression régulière à retour arrière (une seule arobase, un point dans le domaine).
export function isValidInvitationEmail(value) {
    const at = value.indexOf("@");
    if (at <= 0 || at !== value.lastIndexOf("@") || /\s/.test(value)) return false;
    const domain = value.slice(at + 1);
    const dot = domain.lastIndexOf(".");
    return dot > 0 && dot < domain.length - 1;
}

export function withoutTrailingDots(value) {
    let end = value.length;
    while (end > 0 && value[end - 1] === ".") end -= 1;
    return value.slice(0, end);
}

/** Message d'erreur si l'email ne peut pas servir au raccordement, null s'il est libre. */

export async function invitationEmailUnavailableMessage(email, ehpadId) {
    const params = ehpadId == null ? { email } : { email, ehpadId };
    try {
        const { data } = await API.get("/admin/ehpads/invitations/email-availability", { params });
        return data?.available === false ? (data.message ?? "Cet email est déjà utilisé.") : null;
    } catch (err) {
        return err.response?.data?.message ?? "Impossible de vérifier l'email de raccordement.";
    }
}

export async function sendEhpadInvitation(email, ehpadId) {
    const { data } = await API.post("/admin/ehpads/invitations", { email, ehpadId });
    return data;
}

/** expiresAt est une heure locale de Paris sans fuseau : lue comme heure locale du navigateur (utilisateurs en France). */

export function invitationExpiryTime(invitation) {
    const time = new Date(invitation.expiresAt).getTime();
    return Number.isNaN(time) ? 0 : time;
}

export function invitationStatusColor(invitation) {
    if (invitation.expired) return "#6b7280";
    return invitation.blocked ? "#dc2626" : "#92400e";
}

export function formatInvitationExpiryTime(invitation) {
    const date = new Date(invitation.expiresAt);
    if (Number.isNaN(date.getTime())) return "";
    return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
}

export function formatInvitationExpiry(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function transferStatus(transfer, clock) {
    if (invitationExpiryTime(transfer) <= clock) return "Transfert expiré";
    const attempts = `${transfer.failedAttempts}/${transfer.maxFailedAttempts ?? 5} erreur${transfer.failedAttempts > 1 ? "s" : ""} de code`;
    if (transfer.blocked) return `Transfert bloqué · ${attempts}`;
    return `Transfert en cours · ${attempts} · expire à ${formatInvitationExpiryTime(transfer)}`;
}

/**
 * Transfert d'un EHPAD qui appartient à une autre pharmacie : invitation (lien et code) à son responsable sur le
 * portail. À la validation du code, l'EHPAD rejoint cette pharmacie ; son historique reste à l'ancienne pharmacie.
 */

export function invitationFailureSentence(err) {
    const reason = withoutTrailingDots((err.response?.data?.message ?? "erreur inconnue").trim());
    if (reason.startsWith("Cet EHPAD est déjà raccordé")) {
        return "L'invitation n'a pas pu être envoyée car cet EHPAD est déjà raccordé.";
    }
    return `L'invitation n'a pas pu être envoyée : ${reason}.`;
}

export function invitationErrorMessage(err, done) {
    return `${done}. ${invitationFailureSentence(err)}`;
}
